import { useMemo } from "react";

import {
  useGetAdminInstrumentTodosQuery,
  useGetAdminTodoQuery,
} from "../../../../services/admin";
import { useGetPendingTickerRequestsQuery } from "../../../../services/tickerRequests";
import { reviewableActionCount } from "../../utils/corporateActions";
import { toPendingFixItems } from "../utils/toWorkItem";

export const usePendingWorkCount = (): number => {
  const requests = useGetPendingTickerRequestsQuery();
  const fixes = useGetAdminInstrumentTodosQuery();
  const todo = useGetAdminTodoQuery();
  const requestCount = requests.isError ? 0 : (requests.data?.length ?? 0);
  const fixData = fixes.data;
  const pendingFixCount = useMemo(
    () => (fixData ? toPendingFixItems(fixData).length : 0),
    [fixData],
  );
  const fixCount = fixes.isError ? 0 : pendingFixCount;
  const actionCount =
    !todo.isError && todo.data?.availability === "available"
      ? reviewableActionCount(todo.data.data)
      : 0;
  return requestCount + fixCount + actionCount;
};
